module.exports = __webpack_public_path__ + "img/building.e8358bb5.jpg";